module.exports = "<ng-include src=\"'app/poi/view/general/partial_descriptions.html'\"></ng-include> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/view/general/partial_summit.html
// module id = 455
// module chunks = 0